<script lang="ts">
  import { i18n } from "../i18n.svelte";
  const s = $derived(i18n.t.subjects);
</script>

<div class="band">
  <div class="container row">
    <span class="label">{s.label}</span>
    <div class="track" aria-hidden="true">
      <div class="marquee">
        {#each [...s.items, ...s.items] as item}
          <span class="item"><span class="bullet">●</span>{item}</span>
        {/each}
      </div>
    </div>
  </div>
</div>

<style>
  .band {
    border-block: 1px solid var(--line);
    background: var(--paper-deep);
  }
  .row {
    display: flex;
    align-items: center;
    gap: 1.5rem;
    height: 64px;
  }
  .label {
    flex: none;
    font-family: var(--font-mono);
    font-size: var(--fs-label);
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: var(--muted);
  }
  .track {
    position: relative;
    flex: 1;
    overflow: hidden;
    -webkit-mask-image: linear-gradient(90deg, transparent, #000 6%, #000 94%, transparent);
    mask-image: linear-gradient(90deg, transparent, #000 6%, #000 94%, transparent);
  }
  .marquee {
    display: inline-flex;
    align-items: center;
    gap: 2.2rem;
    white-space: nowrap;
    animation: scroll 28s linear infinite;
  }
  .item {
    display: inline-flex;
    align-items: center;
    gap: 0.7rem;
    font-family: var(--font-mincho);
    font-size: 1.15rem;
    color: var(--ink-soft);
  }
  .bullet {
    color: var(--sprout);
    font-size: 0.5rem;
  }
  @keyframes scroll {
    to {
      transform: translateX(-50%);
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .marquee {
      animation: none;
    }
  }
  @media (max-width: 640px) {
    .label {
      display: none;
    }
  }
</style>
